import React from 'react'

const Dots = () => {
    return (
        <div><div className='flex flex-col gap-5'>
            <div className='flex gap-3'>
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
            </div>
            <div className='flex gap-3'>
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
                <div className='h-1 w-1 rounded-full bg-green-600' />
            </div>
            <div>

            </div>
        </div></div>
    )
}

export default Dots